"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardTitleText = require("./CardTitleText.styles");

var _formatters = require("../../../../helpers/formatters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources

/**
 * CardTitleText is most often used in conjunction with a header-less card
 */
// intentionally left as a functional component
var CardTitleText = function CardTitleText(_ref) {
  var alignment = _ref.alignment,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_CardTitleText.StyledCardTitleText, {
    alignment: alignment,
    className: className,
    dataTestId: "card-title-".concat((0, _formatters.toKabobCase)(children))
  }, children);
};

CardTitleText.propTypes = {
  /** alignment hook */
  alignment: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** children components or just plain old text */
  children: _propTypes.default.string.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string
};
CardTitleText.defaultProps = {
  alignment: undefined,
  className: ''
};
var _default = CardTitleText;
exports.default = _default;